<template>
    <div v-if="activeTab === name" class="vue__tabs-content">
        <slot />
    </div>
</template>

<script setup>
import {computed, getCurrentInstance} from "vue";

let parent = getCurrentInstance()?.parent

while(typeof parent?.exposed?.activeTab === 'undefined') {
    parent = parent.parent
}

const activeTab = computed(() => parent.exposed?.activeTab.value)

defineProps({
    name: {
        type: [String, Number],
        required: true
    }
})
</script>
